export default __webpack_public_path__ + "static/media/config-hris1.7968fe50.svg";